import { render, staticRenderFns } from "./DocumentsSynthesisQuestion.vue?vue&type=template&id=e7d21618"
import script from "./DocumentsSynthesisQuestion.vue?vue&type=script&lang=ts"
export * from "./DocumentsSynthesisQuestion.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsSynthesisQuestion.vue?vue&type=style&index=0&id=e7d21618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports